/**
 * @generated SignedSource<<ca70df65e8351e46a2ec0edd497a3cf4>>
 * @relayHash 7a016240d0d07b31c18b12ceba9b568a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7a016240d0d07b31c18b12ceba9b568a

import { ConcreteRequest } from 'relay-runtime';
export type FeatureFlagType = "B2B_DATA_IMPORT_ENABLED" | "CHAT_AUTO_TRANSLATION" | "GENESYS_TELEPHONY" | "SPEECH_TO_TEXT";
export type useIsFeatureEnabledQuery$variables = {
  flags: ReadonlyArray<FeatureFlagType>;
};
export type useIsFeatureEnabledQuery$data = {
  readonly featureFlags: ReadonlyArray<{
    readonly featureFlag: FeatureFlagType;
    readonly isEnabled: boolean;
  }>;
};
export type useIsFeatureEnabledQuery = {
  response: useIsFeatureEnabledQuery$data;
  variables: useIsFeatureEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "flags"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "featureFlags",
    "variableName": "flags"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useIsFeatureEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "FeatureFlagResponse",
        "kind": "LinkedField",
        "name": "featureFlags",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useIsFeatureEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "FeatureFlagResponse",
        "kind": "LinkedField",
        "name": "featureFlags",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7a016240d0d07b31c18b12ceba9b568a",
    "metadata": {},
    "name": "useIsFeatureEnabledQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "464b5c21331926b07df607b7a3a5d1f0";

export default node;
